import React from "react";

// ----- Stat tile -----------------------------------------------------
export default function StatCard({ label, value, sub, tone }) {
  // tone: 'good' | 'warn' | 'bad' | undefined
  const subColor =
    tone === "good" ? "#1b6b1e" :
    tone === "warn" ? "#8a5a00" :
    tone === "bad"  ? "#a23a3a" :
    "#5c7c7f";
  return (
    <div className="card" style={{ padding: 16 }}>
      <div className="muted" style={{ fontSize: "0.78rem", textTransform: "uppercase", letterSpacing: 0.5 }}>
        {label}
      </div>
      <div style={{ fontSize: "1.85rem", fontWeight: 700, marginTop: 4, lineHeight: 1.1 }}>
        {value ?? "…"}
      </div>
      {sub && (
        <div style={{ fontSize: "0.82rem", marginTop: 4, color: subColor }}>
          {sub}
        </div>
      )}
    </div>
  );
}
